'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SNOWPLOW_CDN = exports.SNOWPLOW_CDN = '//static.hudl.com/uat/2.13.0/ayN19xAmEN8pEGaM.js';

// snowplow methods
var NEW_TRACKER = exports.NEW_TRACKER = 'newTracker';
var SET_USERID = exports.SET_USERID = 'setUserId';
var TRACK_CUSTOM_EVENT = exports.TRACK_CUSTOM_EVENT = 'trackSelfDescribingEvent';

// schema
var SESSION_HEARTBEAT_EVENT_SCHEMA = exports.SESSION_HEARTBEAT_EVENT_SCHEMA = 'iglu:com.hudl/heartbeat_event/jsonschema/1-0-0';
var SESSION_VIEW_EVENT_SCHEMA = exports.SESSION_VIEW_EVENT_SCHEMA = 'iglu:com.hudl/view_event/jsonschema/1-0-0';

var VIDEO_ACTIVITY_HEARTBEAT_EVENT_SCHEMA = exports.VIDEO_ACTIVITY_HEARTBEAT_EVENT_SCHEMA = 'iglu:com.hudl/video_playback_heartbeat_event/jsonschema/1-0-0';

var USER_ENTITY_SCHEMA = exports.USER_ENTITY_SCHEMA = 'iglu:com.hudl/user_entity/jsonschema/3-0-0';
var TEAM_ENTITY_SCHEMA = exports.TEAM_ENTITY_SCHEMA = 'iglu:com.hudl/team_entity/jsonschema/4-0-0';
var VIDEO_ENTITY_SCHEMA = exports.VIDEO_ENTITY_SCHEMA = 'iglu:com.hudl/video_entity/jsonschema/2-0-0';
var PLAYLIST_ENTITY_SCHEMA = exports.PLAYLIST_ENTITY_SCHEMA = 'iglu:com.hudl/playlist_entity/jsonschema/2-0-1';
var PLAYLIST_CLIP_ENTITY_SCHEMA = exports.PLAYLIST_CLIP_ENTITY_SCHEMA = 'iglu:com.hudl/playlist_clip_entity/jsonschema/1-0-0';

// debounce
var DEBOUNCE_MS = exports.DEBOUNCE_MS = 400;

// heartbeat interval variance allowed (+25%)
var MAX_HEARTBEAT_VARIANCE = exports.MAX_HEARTBEAT_VARIANCE = 1.25;